<template>
  <div class="content">
    <el-row style="height:28px">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <!-- <el-breadcrumb-item>系统配置</el-breadcrumb-item> -->
            <el-breadcrumb-item>会议室管理</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <el-container style="height:calc(100% - 30px);width:100%;position: relative;">
      <el-main style="height: 100%;padding:0px !important;  position: relative;width: 100%;">
        <el-card style="height:100% !important;" class="aside">
          <!--  -->
          <div class="build-table">
            <div style="display:flex;width:100%;height:80px;align-items:center;justify-content: space-between;padding:0px 10px">
              <div>
                <span>会议日期</span>
                <el-date-picker
                  v-model="time1"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  style="width:130px;font-size:12px;margin-right:20px"
                ></el-date-picker>
                <el-button type="primary" @click="doFilter">查询</el-button>
              </div>
              <el-button type="primary" icon="el-icon-plus" @click="addFun">申请会议</el-button>
            </div>
            <div
              style="height:60px;border-top:10px solid #f5f5f5;width:100%;display:flex;align-items:center;"
            >
              <span
                @click="selectTab(0)"
                style="margin:0  25px;padding:5px"
                :class="{'cur':status==0}"
              >已预约</span>
              <span
                @click="selectTab(1)"
                style="margin:0  25px;padding:5px"
                :class="{'cur':status==1}"
              >已完成</span>
              <span
                @click="selectTab(2)"
                style="margin:0  25px;padding:5px"
                :class="{'cur':status==2}"
              >已取消</span>
            </div>
            <!--  -->
            <div style="width:100%;height:calc(100% - 240px)">
              <el-table
                stripe
                :data="listData"
                height="100%"
                border
                style="width: 100%;"
                :default-sort="{prop: 'createDate', order: 'descending'}"
                :header-cell-style="{background:'#F5F7F9',color:'#909399',}"
                :cell-style="rowClass"
              >
                <template slot="empty">
                  <p>{{dataText}}</p>
                </template>
                <el-table-column label="序号" width="100">
                  <template slot-scope="scope">
                    <a>{{ scope.row.index}}</a>
                  </template>
                </el-table-column>
                <!-- <el-table-column label="日期">
                  <template slot-scope="scope">
                    <a>{{ scope.row.title}}</a>
                  </template>
                </el-table-column>-->
                <el-table-column label="时间">
                  <template slot-scope="scope">
                    <a>{{ scope.row.startTime}} - {{scope.row.endTime}}</a>
                  </template>
                </el-table-column>
                <el-table-column label="所属组织" :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                    <span>{{ scope.row.officeName }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="会议主题" :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                    <span>{{ scope.row.topic }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="主持人">
                  <template slot-scope="scope">
                    <span>{{ scope.row.compere}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="备注">
                  <template slot-scope="scope">
                    <span>{{ scope.row.remarks }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="200" v-if="status==0&&isMenuExit('pro:meet:cancel')">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      type="primary"
                      @click.native.stop="handleEdit(scope.$index, scope.row)"  
                    >取消预约</el-button>
                  </template>          
                </el-table-column>
                <el-table-column label="取消原因" width="200" v-if="status==2">
                  <template slot-scope="scope">
                    <span>{{ scope.row.reason }}</span>
                  </template>
                </el-table-column>
              </el-table>
              <!-- 添加公告弹框 -->
              <!-- 新增窗口 -->
              <el-dialog
                :title="dialogTitle"
                :visible.sync="addFormVisible"
                center
                width="800px"
                :append-to-body="true"
                :lock-scroll="false"
                class="add-form"
              >
                <el-form
                  :model="addForm"
                  label-width="200px"
                  ref="addForm"
                  label-position="right"
                  :rules="rules"
                >
                  <el-form-item label="会议起始时间">
                    <div class="block">
                      <!-- <el-date-picker
                        v-model="time"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        type="datetimerange"
                        :picker-options="pickerOptions"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        align="right"
                      ></el-date-picker> -->
                        <el-date-picker
                        v-model="startTime"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm"
                        format="yyyy-MM-dd HH:mm"
                        placeholder="选择会议开始时间">
                      </el-date-picker>
                    </div>
                  </el-form-item>
                    <el-form-item label="会议结束时间">
                    <div class="block">
                     <el-time-picker
                            v-model="endTime"
                             value-format="HH:mm"
                             format="HH:mm"
                            :picker-options="{
                            }"
                            placeholder="选择会议结束时间">
                          </el-time-picker>
                    </div>
                  </el-form-item>
                  <el-form-item label="组织" prop="type">
                    <el-select v-model="addForm.officeId" placeholder="请选择">
                      <el-option
                        v-for="item in office"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                   <el-form-item label="主持人" prop="compere">
                    <el-input
                      v-model="addForm.compere"
                      autocomplete="off"
                      style="width:217px"
                    ></el-input>
                  </el-form-item>
                   <el-form-item label="手机号" prop="topic">
                    <el-input
                      v-model="addForm.phone"
                      autocomplete="off"
                      style="width:217px"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="会议主题" prop="topic">
                    <el-input
                      v-model="addForm.topic"
                      type="textarea"
                      :rows="4"
                      autocomplete="off"
                      style="width:217px"
                    ></el-input>
                  </el-form-item>
                  
                  <el-form-item label="备注：" prop="remarks">
                    <el-input
                      type="textarea"
                      :rows="2"
                      v-model="addForm.remarks"
                      autocomplete="off"
                      style="width:217px;height:200px"
                    ></el-input>
                  </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                  <el-button @click="addFormVisible = false">取 消</el-button>
                  <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
                </div>
              </el-dialog>
              <!-- 取消预约 -->
              <el-dialog
                :title="dialogTitle"
                :visible.sync="editFormVisible"
                center
                width="800px"
                :append-to-body="true"
                :lock-scroll="false"
                class="add-form"
              >
                <el-form
                  :model="editForm"
                  label-width="200px"
                  ref="editForm"
                  label-position="right"
                  :rules="rules"
                >
                  <el-form-item label="取消原因" prop="topic">
                    <el-input
                      v-model="editForm.reason"
                      type="textarea"
                      :rows="4"
                      autocomplete="off"
                      style="width:217px"
                    ></el-input>
                  </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                  <el-button @click="editFormVisible = false">取 消</el-button>
                  <el-button type="primary" @click="sumbitAddRow1('editForm')">确 定</el-button>
                </div>
              </el-dialog>
            </div>
            <!-- 分页展示 -->
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[3, 5, 10,20]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalItems"
            ></el-pagination>
          </div>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import util from '../../untils/util'
import myHttp from '../../untils/port'
import base from '../../untils/base'
export default {
  data() {
    return {
      search: {},
      listData: [], //表格数据
      addForm: {
        id: '',
        entId: '',
        startTime: '',
        endTime: '',
        topic: '',
        remarks: '',
        officeId: '',
        compere:'',
        phone:''
      },
      dialogTitle: '',
      addFormVisible: false,
      groupId: '',
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      storeOpt: [], //题库

      dataText: '数据加载中...',
      rules: {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        content: [{ required: true, message: '请输入内容', trigger: 'blur' }],
      },
      groupType: '',
      groupId: '',
      createBy: util.session.get('user').id,
      uploadphotoUrl: base.url + '/upload/uploadPhotosAndThumbnail',
      uploadHead: {
        accessToken: util.session.get('token'),
      },
      uploadphotoData: {
        type: '221',
      },
      type: 1,
      dialogImageUrl: '',
      dialogVisible: false,
      photoList: [], //多张普通图片
      photoThum: [], //多张缩略图
      time1: '',
      status: '0',
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
      time: '',
      endTime:'',
      editFormVisible: false,
      editForm: {
        reason: '',
      },
      office: [], //组织机构
      startTime:'',
    }
  },

  mounted() {
    this.groupId = util.session.get('groupId')
    // console.log(this.addForm.scope)
    if ('' == this.groupId) {
      this.$store.commit('setGroupId')
      this.$store.commit('getRoleId')
      this.groupId = this.$store.state.groupId
    }
    this.search.groupId = this.groupId
    if (util.session.get('roleId') == '3') {
      this.groupType = '3'
    } else if (this.$store.state.roleId == '4') {
      this.groupType = '1'
    } else if (this.$store.state.roleId == '5') {
      this.groupType = '2'
    }
    console.log(this.startTime)
    this.getData()
    this.getoffice()
  },
  methods: {
    //查询
    doFilter() {
      this.getData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.currentChangePage()
    },
    // 监控当前页码
    currentChangePage(list) {
      this.getData()
    },
    rowClass() {
      //表头居中显示
      return 'text-align:center'
    },
    // 获取数据
    getData() {
      var that = this
      this.search.entId = this.groupId
      this.search.pageSize = this.pageSize
      this.search.pageNum = this.currentPage
      this.search.time = this.time1
      this.search.status = this.status
      myHttp.pageInfoMetting(this.search).then(
        function (resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.meettingPageInfo.list || []
            for (var i = 0; i < list.length; i++) {
              list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
              list[i].thumbnailUrl_view = list[i].thumbnailUrl
                ? base.httpCtx + list[i].thumbnailUrl
                : ''
            }
            that.totalItems = resp.data.data.meettingPageInfo.total || 0
            that.listData = list
            if (that.listData.length == 0) {
              that.dataText = '暂无数据'
            }
          } else {
            that.$message.error(resp.data.msg)
            that.dataText = '服务器出错'
          }
        },
        function () {}
      )
    },
    //修改
    handleEdit(index, row) {
      this.dialogTitle = '取消预约'
      var that = this
      this.editFormVisible = true
      this.editForm.id = row.id
    },
    //保存
    sumbitAddRow(formName) {
      var that = this
      var year = this.startTime.split(' ')[0]
      this.addForm.entId = this.groupId
      // this.addForm.groupType = this.groupType
      this.addForm.createBy = this.createBy
      this.addForm.startTime = this.startTime
      this.addForm.endTime =year +' '+ this.endTime
    
      this.$refs[formName].validate((valid) => {
        if (valid) {
          myHttp.createInfoMeet(that.addForm).then(function (resp) {
            if (resp.data.code == '200') {
              that.addFormVisible = false
              that.$message.success('会议创建成功')
              that.getData()
            } else {
              that.$message.error(resp.data.msg)
            }
          })
        }
      })
    },
    //取消预约
    sumbitAddRow1(formName) {
      var that = this
      this.editForm.entId = this.groupId
      // this.addForm.groupType = this.groupType
      this.editForm.updateBy = this.createBy
      this.editForm.status = '2'
      // console.log(this.addForm)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          myHttp.updateInfoMetting(that.editForm).then(function (resp) {
            if (resp.data.code == '200') {
              that.editFormVisible = false
              that.$message.success(resp.data.msg)
              that.getData()
            } else {
              that.$message.error(resp.data.msg)
            }
          })
        }
      })
    },
    // handleNodeClick(data) {
    //   console.log(data)
    // },
    //添加
    addFun() {
      this.dialogTitle = '添加会议'
      this.checkData = []
      this.addForm = {
        id: '',
        title: '',
        content: '',
        thumbnailUrl: '', //缩略图片
        photoUrl: '', //图片
        type: '1', //1公告 2法律法规
        getoffice: '',
      }
      this.addFormVisible = true
      // this.$router.push({path:'/textRich/'+this.type})
    },
    //删除
    handleDel(index, row) {
      var that = this
      this.$confirm('此操作将永久删除该公告, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          myHttp
            .deleteInfoNo({
              id: row.id,
              updateBy: this.createBy,
            })
            .then(function (resp) {
              if (resp.data.code == '200') {
                that.$message.success('删除成功')
                that.getData()
              } else {
                that.$message.error(resp.data.msg)
              }
            })
        })
        .catch((err) => {})
    },
    handleRemove(file, fileList) {
      console.log(file, fileList)
      if ((file.response.code = 200)) {
        var arr1 = file.response.data.savePhotoUrls.split(',')
        var arr2 = file.response.data.saveThumbnailUrls.split(',')
        console.log(arr1, arr2)
        //        photoList:[], //多张普通图片
        // photoThum:[],//多张缩略图

        // 删除
        for (var i = 0; i < this.photoList.length; i++) {
          for (var j = 0; j < arr1.length; j++) {
            if (this.photoList[i] == arr1[j]) {
              this.photoList[i] = ''
              // this.photoList.push(this.photoList[i])
            }
          }
        }
        //
        for (var i = 0; i < this.photoThum.length; i++) {
          for (var j = 0; j <= arr2.length; j++) {
            if (this.photoThum[i] == arr2[j]) {
              this.photoThum[i] = ''
              // this.photoThum.push(this.photoThum[i])
            }
          }
        }

        for (var i = 0; i < this.photoList.length; i++) {
          if (this.photoList[i] == '') {
            this.photoList.splice(i, 1)
            i = i - 1
          }
        }
        for (var i = 0; i < this.photoThum.length; i++) {
          if (this.photoThum[i] == '') {
            this.photoThum.splice(i, 1)
            i = i - 1
          }
        }
        // 删除图片后的路径
        this.addForm.photoUrl = this.photoList.join(',')
        this.addForm.thumbnailUrl = this.photoThum.join(',')
        // console.log(this.photoList, this.photoThum)
        // console.log(this.addForm.photoUrl, this.addForm.thumbnailUrl)
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    // 上传封面图片成功
    handleIconSuccess(res, file) {
      if (res.code == '200') {
        console.log(res)
        this.photoList.push(res.data.savePhotoUrls)
        this.photoThum.push(res.data.saveThumbnailUrls)
        //  console.log( this.photoList,this.photoThum)
        this.addForm.photoUrl = this.photoList.join(',')
        this.addForm.thumbnailUrl = this.photoThum.join(',')
        // console.log(this.addForm.photoUrl, this.addForm.thumbnailUrl)
      } else {
        this.$message.error(res.msg)
      }
    },
    // 点击详情事件
    // openDetails(row) {
    //   console.log(row.id)
    //   this.$router.push({ path: '/noticeDetails/' + row.id + '/' + this.type })
    // },
    selectTab(index) {
      this.status = index
      this.getData()
    },
    // 组织机构
    getoffice() {
      var that = this
      // getofficePageList
      myHttp
        .getofficePageList({
          entId: this.groupId,
        })
        .then(
          function (resp) {
            if (resp.data.code == '200') {
              that.office = resp.data.data.officeList || []
            } else {
              that.$message.error(resp.data.msg)
              that.dataText = '服务器出错'
            }
          },
          function () {}
        )
    },
       /**
     * 判断是否展示
     */
    isMenuExit(row){
      console.log(row)
        var flag = util.common.filterBtnMenu(row)
        console.log(flag)
        return flag
        
    },
  },
}
</script>
<style>
@import '../../assets/css/common.css';
</style>
<style scoped>
.content >>> .el-card__body {
  padding: 0 !important;
  height: 100% !important;
}
.grid-content {
  height: 2.5vh;
  font-size: 1.6vh;
}
.aside {
  box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
  border-radius: 10px !important;
  border: 0px !important;
  background-color: #ecf0f5;
  display: flex;
  flex-direction: column;
}
.search-section {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 20px 35px 20px -12px;
  height: 40px;
  justify-content: space-between;
}
.el-end {
  height: 47px;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  text-align: center;
}
.build-table {
  height: 100%;
  width: 100%;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  background: #fff;
}
.el-pagination {
  margin: auto;
}
.el-table--fit {
  border-bottom: 1px solid #f5f5f5;
}
.content >>> .el-table th > .cell {
  text-align: center !important;
}
.content >>> .el-table tr {
  cursor: pointer;
}
.cur {
  border-bottom: 3px solid #17b2fe;
}
</style>